/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createSkillAssignmentRequestSchema = z.object({
  resourceId: z.int(),
  skillId: z.int(),
});
